import {
  ShipmentTransportSegment,
  ShipOrder,
  ShipOrderSplitCommand,
} from '@/model';
import {
  SplitShipOrderPayload,
  SplitShipOrderResponse,
} from '@/model/routeBuilder';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'ship-order';

export class ShipOrderController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async create(shipOrder: ShipOrder): Promise<ShipOrder> {
    if (shipOrder.id != null) {
      throw new Error('Id expected to be null when calling create');
    }

    const response = await this.http.post<ShipOrder>('', shipOrder);
    return new ShipOrder(response.data);
  }

  async findById(shipOrderId: number): Promise<ShipOrder> {
    const response = await this.http.get<ShipOrder>(`${shipOrderId}`);
    return new ShipOrder(response.data);
  }

  async findAllUnplanned(): Promise<ShipOrder[]> {
    const response = await this.http.get<ShipOrder[]>('unplanned');
    return response.data.map((val) => new ShipOrder(val));
  }

  async findTransportSegmentsForShipOrder(
    shipOrderId: number,
  ): Promise<ShipmentTransportSegment[]> {
    const response = await this.http.get<ShipmentTransportSegment[]>(
      `${shipOrderId}/transport-segment`,
    );

    return response.data
      .map((val) => new ShipmentTransportSegment(val))
      .sort((a, b) => a.sequence - b.sequence);
  }

  async split(shipOrderSplitCommand: ShipOrderSplitCommand): Promise<void> {
    await this.http.post<void>(
      `${shipOrderSplitCommand.shipOrderId}/split`,
      shipOrderSplitCommand,
    );
  }

  async splitBeta({
    shipOrder,
    splitLineItems,
  }: SplitShipOrderPayload): Promise<SplitShipOrderResponse> {
    const response = await this.http.post<SplitShipOrderResponse>(
      `${shipOrder.id}/split`,
      {
        shipOrderId: shipOrder.id,
        splitLineItems,
      },
    );

    return new SplitShipOrderResponse(response.data);
  }
}
